import React, { Component } from "react";
import {
  DesignedButtonWrapper,
  TextContainer,
  Text
} from "./DesignedButton.style";
import PropTypes from 'prop-types'

export class DesignedButton extends Component {
  render() {
    const { text, onClick ,img ,width,left,disabled,displayNone} = this.props;
    var color = this.props.color === undefined ? "green" : this.props.color;
    const margin = this.props.margin === undefined ? "auto" : this.props.margin;
    return (
      <DesignedButtonWrapper disabled={disabled} margin={margin} color={color} onClick={onClick} left={left}>
        <TextContainer color={color} width = {width}>
          <Text lang={this.props.value} color={color}  left={left}  displayNone={displayNone} >{text}<img src={img ? img : "https://front.videomonster.com/images-7cuytg20/web/arrow_w.svg"} alt="" ></img></Text>
        </TextContainer>
      </DesignedButtonWrapper>
    );
  }
}
DesignedButton.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};